export const PHONE_RAW = "+2349068077777";
export const PHONE_DISPLAY = "+234 906 807 7777";
export const TEL_HREF = "tel:+2349068077777";
export const WHATSAPP_HREF =
  "https://wa.me/2349068077777?text=Hello%20Ascentix%20Dev%2C%20I%27d%20like%20to%20enquire%20about%20training%20or%20leadership%20development%20support%20for%20my%20organisation.";
export const EMAIL = "info@ascentixdevelopment.com";
export const SPRK_URL = "https://buildsprk.com";
